<template>
  <div class="row main-content">
    <div class="col">
      <div
        v-if="isProcessing"
        class="text-center"
      >
        <img
          src="@/assets/img/loader.gif"
          class="mx-auto d-block center-block"
        >
      </div>

      <div v-else>
        <h1 class="page-title font-custom text-uppercase mt-3">
          {{ $t('label.operation.operationDetail') }}
        </h1>

        <div
          v-if="responseErr"
          class="alert alert-danger text-center border-0 shadow-sm rounded-0"
        >
          <strong>
            {{ $t('error.'+`${responseErr}`) }}
          </strong>
        </div>

        <div
          v-if="$store.state.operations.operationDetail"
        >
          <div
            id="accordionDetail"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingDetail"
              data-bs-toggle="collapse"
              href="#collapseDetail"
              aria-expanded="false"
              aria-controls="collapseDetail"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.operation.details') }}
            </div>
            <div
              id="collapseDetail"
              aria-labelledby="headingDetail"
              data-bs-parent="#accordionDetail"
              class="card-body collapse "
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.status') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.status) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.acquisitionCountryCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.acquisitionCountryCode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.acquisitionDate') }}
                </div>
                <div class="col">
                  {{ $filters.date($store.state.operations.operationDetail.acquisitionDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.acquisitionMaterial') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.acquisitionMaterial) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.cardSchemeCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.cardSchemeCode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.entryMode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.entryMode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.externalReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.externalReference) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.genericMCC') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.genericMCC) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.merchantNameAndLoc') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.merchantInformation) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.operationCode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.operationCode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.operationDate') }}
                </div>
                <div class="col">
                  {{ $filters.date($store.state.operations.operationDetail.operationDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.originalAmount') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.originalAmount) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.reversal') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.reversal) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.reversalReason') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.reversalReason) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.validationMode') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.validationMode) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.valueDate') }}
                </div>
                <div class="col">
                  {{ $filters.date($store.state.operations.operationDetail.valueDate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.cardExternalReference') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.cardExternalReference) }}
                </div>
              </div>
            </div>
          </div>

          <div
            id="accordionCompte"
            class="card rounded-0 mb-4"
          >
            <div
              id="headingCompte"
              data-bs-toggle="collapse"
              href="#collapseCompte"
              aria-expanded="false"
              aria-controls="collapseCompte"
              class="card-header font-accent fw-bold"
            >
              {{ $t('label.operation.account') }}
            </div>
            <div
              id="collapseCompte"
              aria-labelledby="headingCompte"
              data-bs-parent="#accordionCompte"
              class="card-body collapse "
            >
              <div class="row">
                <div class="col-3 text-end">
                  {{ $t('label.operation.account') }}
                </div>
                <div class="col">
                  <template v-if=" $store.state.operations.operationDetail.accountDetailsPageContext ">
                    <strong>
                      <div
                        role="button"
                        class="clickable-div"
                        @click="showAccount($store.state.operations.operationDetail.accountDetailsPageContext)"
                      >
                        {{ $t('label.account.beneficiaryAccount') }}
                      </div>
                    </strong>
                  </template>
                  <template v-else-if="$store.state.accounts.account.singleFunderAccount">
                    <strong>
                      {{ $t('label.account.funderAccount') }}
                    </strong>
                  </template>
                  <template v-else>
                    --
                  </template>
                </div>
              </div>
              <div
                v-if="($store.state.accounts.account.beneficiaryServiceRef && !$store.state.accounts.account.singleFunderAccount) || (!$store.state.accounts.account.beneficiaryServiceRef && $store.state.accounts.account.singleFunderAccount)"
                class="row"
              >
                <div class="col-3 text-end">
                  {{ $t('label.account.balance') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.accountBalance == "UNKNOWN" ? $store.state.accounts.accountDetail.accountBalance : $store.state.operations.operationDetail.accountBalance) }}
                </div>
              </div>
              <div
                v-if="$store.state.accounts.account.beneficiaryServiceRef || !$store.state.accounts.account.singleFunderAccount"
                class="row"
              >
                <div class="col-3 text-end">
                  {{ $t('label.account.openToBuy') }}
                </div>
                <div class="col">
                  {{ $filters.nullFilter($store.state.operations.operationDetail.accountAvailable == "UNKNOWN" ? $store.state.accounts.accountDetail.accountAvailable : $store.state.operations.operationDetail.accountAvailable) }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="$store.state.operations.operationDetail.cardAndOrderListIsNotNull">
            <div
              v-if="$store.state.operations.operationDetail.cards"
              id="accordionCartes"
              class="card rounded-0 mb-4"
            >
              <div
                id="headingCartes"
                data-bs-toggle="collapse"
                href="#collapseCartes"
                aria-expanded="false"
                aria-controls="collapseCartes"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.operation.cards') }}
              </div>
              <div
                id="collapseCartes"
                aria-labelledby="heading3Cartes"
                data-bs-parent="#accordionCartes"
                class="card-body collapse "
              >
                <div v-if="$store.state.operations.operationDetail.cards">
                  <div
                    v-for="opcCard in $store.state.operations.operationDetail.cards"
                    :key="opcCard.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardId') }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showCard(opcCard)"
                          >
                            {{ opcCard.cardId }}
                          </div>
                        </strong>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.cardStatus') }}
                      </div>
                      <div class="col">
                        {{ $filters.nullFilter(opcCard.cardStatus) }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.panCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.panCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.psnCard') }}
                      </div>
                      <div class="col">
                        {{ opcCard.psnCard }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.cards.expiryDate') }}
                      </div>
                      <div class="col">
                        {{ opcCard.expiryDate }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="$store.state.operations.operationDetail.orders"
              id="accordionCommandes"
              class="card rounded-0 mb-4"
            >
              <div
                id="headingCommandes"
                data-bs-toggle="collapse"
                href="#collapseCommandes"
                aria-expanded="false"
                aria-controls="collapseCommandes"
                class="card-header font-accent fw-bold"
              >
                {{ $t('label.operation.orders') }}
              </div>
              <div
                id="collapseCommandes"
                aria-labelledby="headingCommandes"
                data-bs-parent="#accordionCommandes"
                class="card-body collapse "
              >
                <div v-if="$store.state.operations.operationDetail.orders">
                  <div
                    v-for="opcOrder in $store.state.operations.operationDetail.orders"
                    :key="opcOrder.id"
                    class="border-top"
                  >
                    <div class="row">
                      <div class="col-2 text-end">
                        {{ opcOrder.orderType }}
                      </div>
                      <div class="col">
                        <strong>
                          <div
                            role="button"
                            class="clickable-div"
                            @click="showOrder(opcOrder)"
                          >
                            n° {{ opcOrder.orderId }}
                          </div>
                        </strong>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.expeditionRef') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.expeditionRef }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 text-end">
                        {{ $t('label.card.detail.orders.orderStatus') }}
                      </div>
                      <div class="col">
                        {{ opcOrder.orderStatus }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <goTopButton />
  </div>
</template>

<script src="./OperationDetail.js"></script>

<style src="./OperationDetail.scss" scoped lang="scss"></style>
